import React from 'react';
export function EditorColorFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.069 13l-2.75-7h-.638l-2.75 7h6.138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2v20h20V2H2zm9 2h2a1 1 0 01.93.634l5.5 14a1 1 0 01-1.86.732L15.853 15H8.146L6.43 19.366a1 1 0 01-1.862-.732l5.5-14A1 1 0 0111 4z"
  }));
}